import { render, staticRenderFns } from "./kzIndex.vue?vue&type=template&id=d25c99ac&"
import script from "./kzIndex.vue?vue&type=script&lang=js&"
export * from "./kzIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "kzIndex.vue"
export default component.exports